export const dataToSeries = (name: string, data: {date: string; value: number}[]) => {
  let values = data.map((item) => item.value)

  // const dates = data.map((item) => new Date(item?.date).toLocaleDateString())
  let dates = data.map((item) => item.date)

  const series = [
    {
      name,
      data: values,
    },
  ]

  const categories = dates

  return {series, categories}
}

export const dateToSeriesTime = (
  name: string,
  data: {percentageValue: number; period: number; revenue: number}[]
) => {
  const values = data.map((item) => item.revenue)
  const percentages = data.map((item) => item.percentageValue)

  const series = [
    {
      name,
      data: values,
    },
  ]

  return {series, percentages}
}
